import { configureStore } from '@reduxjs/toolkit';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import KararDestekSlice from './Slices/KararDestekSlices';
import KimlikSlice from './Slices/Genel/KimlikSlice';
import ReferansDoktorSlice from './Slices/GenelTanimlar/ReferansDoktorSlice';
import ArayuzYetkiSlice from './Slices/Yetki/ArayuzYetkiSlice';
import PersonelSlice from './Slices/Base/PersonelSlice';
import KullaniciSlice from './Slices/Base/KullaniciSlice';
import KurumSlice from './Slices/GenelTanimlar/KurumSlice';
import PosCihazTanimSlice from './Slices/Vezne/PosCihazTanimSlice';
import VezneYetkiSlice from './Slices/Yetki/VezneYetkiSlice';
import VezneTanimSlice from './Slices/Vezne/VezneTanimSlice';
import MakbuzIzlemeSlice from './Slices/Vezne/MakbuzIzlemeSlice';
import api from 'src/services/core/api';
import BorcTaahhutSlice from './Slices/BorcTaahhut/BorcTaahhutSlice';
import CommonSlice from './Slices/CommonSlice';
import LaboratuvarIzlemeSlice from './Slices/LaboratuvarIzleme/LaboratuvarIzlemeSlice';
import OrganizasyonYetkiSlice from './Slices/Yetki/OrganizasyonYetkiSlice';
import AuthSlice from './Slices/Base/AuthSlice';
import MenuAuthSlice from './Slices/Yetki/MenuAuthSlice';
import VerikontrolSlice from './Slices/Base/VerikontrolSlice';
import ControlAuthSlice from './Slices/Yetki/ControlAuthSlice';
import ParametersSlice from './Slices/Base/ParametersSlice';
import FaturaKurumIcmalleriSlice from './Slices/Fatura/FaturaKurumIcmalleriSlice';
import DrHakedisSlice from './Slices/DrHakedis/DrHakedisSlice';
import MuracaatSlice from './Slices/Muracaat/MuracaatSlice';
import GnlKullaniciVarsayilanSlice from './Slices/Base/GnlKullaniciVarsayilanSlice';
import HastaServisSlice from './Slices/HastaServis/HastaServisSlice';
import LaboratuvarSonucSlice from './Slices/LaboratuvarSonuc/LaboratuvarSonucSlice';
import PrinterSlice from './Slices/Base/PrinterSlice';
import RaporlamaTanimSlice from './Slices/Raporlama/RaporlamaTanimSlice';
import IslemSlice from './Slices/Islem/IslemSlice';
import HastaRaporlamaSlice from './Slices/Raporlama/HastaRaporlamaSlice';
import TeleMedicineSlice from './Slices/TeleMedicine/TeleMedicineSlice';
import TeleDiagnosisTanimSlice from './Slices/TeleDiagnosisTanim/TeleDiagnosisTanimSlice';
import IstemPanelSlice from './Slices/GenelTanimlar/IstemPanelSlice';
import { KurumTanimSlice } from './Slices/KurumTanimTarife/KurumTanimSlice';
import { UcretTarifeTanimSlice } from './Slices/UcretTarifeTanim/UcretTarifeTanimSlice';
import OrganizasyonTanimSlice from './Slices/OrganizasyonTanim/OrganizasyonTanimSlice';
import MuracaatIzlemSlice from './Slices/MuracaatIzlem/MuracaatIzlemSlice';
import IslemTanimRaporSlice from './Slices/GenelTanimlar/IslemTanimRaporSlice';
import HastaDosyalariSlice from './Slices/HastaDosyalari/HastaDosyalariSlice';
import { IslemTanimSlice } from './Slices/Islem/IslemTanimSlice';
import DepoTanimSlice from './Slices/StokEczane/DepoTanimSlice';
import UrunTanimSlice from './Slices/StokEczane/UrunTanimSlice';
import StokGirisSlice from './Slices/StokEczane/StokGirisSlice';
import StokGirisDetaySlice from './Slices/StokEczane/StokGirisDetaySlice';
import { apiMiddleware } from 'src/services/core/ApiErrorMiddleware';
import { KullaniciTarifeSlice } from './Slices/KullaniciTarife/KullaniciTarifeSlice';
import HastaTaniSlice from './Slices/HastaServis/HastaTaniSlice';
import StokCikisSlice from './Slices/StokEczane/StokCikisSlice';
import OrderSlice from './Slices/HastaServis/OrderSlice';
import YatisKabulSlice from './Slices/YatisKabul/YatisKabulSlice';
import ServisProtokolSlice from './Slices/GenelTanimlar/ServisProtokolSlice';
import { ParametreTanimSlice } from './Slices/ParametreTanim/ParametreTanimSlice';
import StokDurumSlice from './Slices/StokEczane/StokDurumSlice';
import YatakTanimSlice from './Slices/GenelTanimlar/YatakTanimSlice';
import KDHastaKayitSlice from './Slices/KurumDisiHastaKayit/KDHastaKayit';
import { PatolojiNumuneKabulSlice } from './Slices/PatolojiModul/PatolojiNumuneKabulSlice';
import { KargoKuryeTakipSlice } from './Slices/KargoKuryeTakip/KargoKuryeTakipSlice';
import OrderIlacSlice from './Slices/HastaServis/OrderIlacSlice';
import ParameterIdSlice from './Slices/Base/ParameterIdSlice';
import { PatolojiLaboratuvarSlice } from './Slices/PatolojiModul/PatolojiLaboratuvarSlice';
import { PatolojiRaporIslemleriSlice } from './Slices/PatolojiModul/PatolojiRaporIslemleriSlice';
import { PatolojiYetkiSlice } from './Slices/PatolojiModul/PatolojiYetkiSlice';
import HastaIzlemSlice from './Slices/IzlemGozlem/HastaIzlemSlice';
import HastaSiviDengeSlice from './Slices/IzlemGozlem/HastaSiviDengeSlice';
import { PatolojiArsivlemeSlice } from './Slices/PatolojiModul/PatolojiArsivlemeSlice';
import RadyolojiCihazTanimSlice from './Slices/RadyolojiModul/RadyolojiCihazTanimSlice';
import RadyolojiCihazTestTanimSlice from './Slices/RadyolojiModul/RadyolojiCihazTestTanimSlice';
import RadyolojiRandevuSablonTanimSlice from './Slices/RadyolojiModul/RadyolojiRandevuSablonTanimSlice';
import HesapPlanTanimSlice from './Slices/GenelTanimlar/HesapPlanTanimSlice';
import { PatolojiArsivHareketleriSlice } from './Slices/PatolojiModul/PatolojiArsivHareketleriSlice';
import MuhasebeIslemlerSlice from './Slices/MuhasebeIslemler/MuhasebeIslemlerSlice';
import EImzaSlice from './Slices/eImza/EImzaSlice';
import { SidebarSlice } from 'src/layouts/contexts/SidebarSlice';
import { HastaRaporSonuclariSlice } from './Slices/HastaRaporSonuclari/HastaRaporSonuclariSlice';
import DepoTalepSlice from './Slices/StokEczane/DepoTalepSlice';
import { RadyolojiKabulSlice } from './Slices/RadyolojiModul/RadyolojiKabulSlice';
import { RadyolojiIslemSlice } from './Slices/RadyolojiModul/RadyolojiIslemSlice';
import { RadyolojiYetkiSlice } from './Slices/RadyolojiModul/RadyolojiYetkiSlice';
import { KullaniciVTYSGrupSlice } from './Slices/Kullanici/KullaniciVTYSGrupSlice';
import { MesajSlice } from './Slices/Mesaj/MesajSlice';
import OrderTalepSlice from './Slices/StokEczane/OrderTalepSlice';
import DepoDurumSlice from './Slices/StokEczane/DepoDurumSlice';
import { SonucIzlemeSlice } from './Slices/SonucIzleme/SonucIzlemeSlice';
import { ServisTanimSlice } from './Slices/ServisTanim/ServisTanimSlice';
import { TaniTanimSlice } from './Slices/TaniTanim/TaniTanimSlice';
import { SablonTanimSlice } from './Slices/SablonTanim/SablonTanimSlice';
import IstemPanelTanimSlice from './Slices/GenelTanimlar/IstemPanelTanimSlice';
import EgitimSlice from './Slices/Egitim/EgitimSlice';
import { SozlesmeIzlemeSlice } from './Slices/Islemler/SozlesmeIzlemeSlice';
import { KurumGrupTanimSlice } from './Slices/KurumGrupTanim/KurumGrupTanimSlice';
import { PatolojiRaporKurtarSlice } from './Slices/PatolojiModul/PatolojiRaporKurtarSlice';
import StokCikisDetaySlice from './Slices/StokEczane/StokCikisDetaySlice';
import HastalikTanimSlice from './Slices/GenelTanimlar/HastalikTanimSlice';
import RaporPersonelSlice from './Slices/Raporlama/RaporPersonelSlice';
import { TedaviUygulamaSlice } from './Slices/Tedavi/TedaviUygulama/TedaviUygulamaSlice';
import HemsireIsliste from 'src/content/pages/HemsireIsListesi';
import { HemsireIsSlice } from './Slices/HemsireIsLsitesi/HemsireIsSlice';
import { BransTanimSlice } from './Slices/GenelTanimlar/BransTanimSlice';
import { rezervBarkodSlice } from './Slices/RezervBarkod/RezervBarkodSlice';
import { kurumBonusTanimlariSlice } from './Slices/KurumBonusTanimlari/KurumBonusTanimlariSlice';
import YetkiTanimSlice from './Slices/Yetki/YetkiTanimSlice';
import { kurumBonusTanimlariTestBazliSlice } from './Slices/KurumBonusTanimlari/KurumBonusTanimlariTestBazliSlice';
import { kurumBonusTanimlariTestVeVeriyeGoreSlice } from './Slices/KurumBonusTanimlari/KurumBonusTanimlariTestVeVeriyeGoreSlice';
import { KurumMailGonderimAyarlariSlice } from './Slices/GenelTanimlar/KurumMailGonderimAyarlariSlice';
import { HastaUyariSlice } from './Slices/HastaUyari/HastaUyariSlice';
import { HastaKaraListeSlice } from './Slices/HastaUyariListesi/HastaKaraListeSlice';
import { SonucIzlemeTanimSlice } from './Slices/GenelTanimlar/SonucIzlemeTanimSlice';
import { RedPanikSlice } from './Slices/RedPanik/RedPanikSlice';
import { TestYineleSlice } from './Slices/TestYinele/TestYineleSlice';



const store = configureStore({
  reducer: {
    [api.reducerPath]: api.reducer, // RTK Query
    userLogin: AuthSlice.reducer,
    userOrganizasyon: OrganizasyonYetkiSlice.reducer,
    menuAuth: MenuAuthSlice.reducer,
    controlAuth: ControlAuthSlice.reducer,
    parameters: ParametersSlice.reducer,
    kararDestek: KararDestekSlice.reducer,
    kimlik: KimlikSlice.reducer,
    referansDoktor: ReferansDoktorSlice.reducer,
    arayuzAuth: ArayuzYetkiSlice.reducer,
    kullanici: KullaniciSlice.reducer,
    personel: PersonelSlice.reducer,
    kurum: KurumSlice.reducer,
    posCihazTanim: PosCihazTanimSlice.reducer,
    vezneYetki: VezneYetkiSlice.reducer,
    vezneTanim: VezneTanimSlice.reducer,
    makbuzIzleme: MakbuzIzlemeSlice.reducer,
    borcTaahhut: BorcTaahhutSlice.reducer,
    common: CommonSlice.reducer,
    laboratuvarIzleme: LaboratuvarIzlemeSlice.reducer,
    verikontrol: VerikontrolSlice.reducer,
    FaturaKurumIcmalleriState: FaturaKurumIcmalleriSlice.reducer,
    DrHakedisSlice: DrHakedisSlice.reducer,
    muracaat: MuracaatSlice.reducer,
    KullaniciVarsayilan: GnlKullaniciVarsayilanSlice.reducer,
    hastaServis: HastaServisSlice.reducer,
    laboratuvarSonuc: LaboratuvarSonucSlice.reducer,
    printer: PrinterSlice.reducer,
    raporlamaTanim: RaporlamaTanimSlice.reducer,
    islem: IslemSlice.reducer,
    hastaRaporlama: HastaRaporlamaSlice.reducer,
    TeleMedicineState: TeleMedicineSlice.reducer,
    TeleDiagnosisTanimState: TeleDiagnosisTanimSlice.reducer,
    IsemPanel: IstemPanelSlice.reducer,
    KurumTanimState: KurumTanimSlice.reducer,
    UcretTarifeTanimState: UcretTarifeTanimSlice.reducer,
    OrganizasyonTanimState: OrganizasyonTanimSlice.reducer,
    MuracaatIzlemState: MuracaatIzlemSlice.reducer,
    islemTanimRapor: IslemTanimRaporSlice.reducer,
    HastaDosyalariState: HastaDosyalariSlice.reducer,
    IslemTanim: IslemTanimSlice.reducer,
    KullaniciTarifeState: KullaniciTarifeSlice.reducer,
    DepoTanim: DepoTanimSlice.reducer,
    UrunTanim: UrunTanimSlice.reducer,
    StokGiris: StokGirisSlice.reducer,
    StokGirisDetay: StokGirisDetaySlice.reducer,
    StokCikis: StokCikisSlice.reducer,
    StokCikisDetay: StokCikisDetaySlice.reducer,
    hastaTani: HastaTaniSlice.reducer,
    order: OrderSlice.reducer,
    StokDurum: StokDurumSlice.reducer,
    yatiskabul: YatisKabulSlice.reducer,
    servisProtokol: ServisProtokolSlice.reducer,
    parametreTanim: ParametreTanimSlice.reducer,
    yatakTanim: YatakTanimSlice.reducer,
    patolojiNumuneKabul: PatolojiNumuneKabulSlice.reducer,
    kargoKuryeTakip: KargoKuryeTakipSlice.reducer,
    kdHastaKayit: KDHastaKayitSlice.reducer,
    orderIlac: OrderIlacSlice.reducer,
    parametreId: ParameterIdSlice.reducer,
    patolojiLaboratuvar: PatolojiLaboratuvarSlice.reducer,
    patolojiRaporIslemleri: PatolojiRaporIslemleriSlice.reducer,
    patolojiYetki: PatolojiYetkiSlice.reducer,
    hastaIzlem: HastaIzlemSlice.reducer,
    hastaSiviDenge: HastaSiviDengeSlice.reducer,
    patolojiArsivleme: PatolojiArsivlemeSlice.reducer,
    radyolojiCihazTanim: RadyolojiCihazTanimSlice.reducer,
    radyolojiCihazTestTanim: RadyolojiCihazTestTanimSlice.reducer,
    radyolojiRandevuSablonTanim: RadyolojiRandevuSablonTanimSlice.reducer,
    hesapPlanTanim: HesapPlanTanimSlice.reducer,
    patolojiArsivHareketleri: PatolojiArsivHareketleriSlice.reducer,
    muhasebeIslemler: MuhasebeIslemlerSlice.reducer,
    eImzaState: EImzaSlice.reducer,
    sidebar: SidebarSlice.reducer,
    hastaRaporSonuclari: HastaRaporSonuclariSlice.reducer,
    depotalep: DepoTalepSlice.reducer,
    radyolojiKabul: RadyolojiKabulSlice.reducer,
    radyolojiIslem: RadyolojiIslemSlice.reducer,
    radyolojiYetki: RadyolojiYetkiSlice.reducer,
    kullaniciVtysGrup: KullaniciVTYSGrupSlice.reducer,
    mesaj: MesajSlice.reducer,
    orderTalep: OrderTalepSlice.reducer,
    depoDurum: DepoDurumSlice.reducer,
    sonucIzleme: SonucIzlemeSlice.reducer,
    servisTanim: ServisTanimSlice.reducer,
    taniTanim: TaniTanimSlice.reducer,
    sablonTanim: SablonTanimSlice.reducer,
    istemPanelTanim: IstemPanelTanimSlice.reducer,
    egitim: EgitimSlice.reducer,
    sozlesmeIzleme: SozlesmeIzlemeSlice.reducer,
    kurumGrupTanim: KurumGrupTanimSlice.reducer,
    patolojiRaporKurtar: PatolojiRaporKurtarSlice.reducer,
    hastalikTanim: HastalikTanimSlice.reducer,
    raporPersonel: RaporPersonelSlice.reducer,

    tedaviUygulama: TedaviUygulamaSlice.reducer,
    hemsireIs: HemsireIsSlice.reducer,
    bransTanim: BransTanimSlice.reducer,
    rezervBarkod: rezervBarkodSlice.reducer,
    kurumBonusTanimlari: kurumBonusTanimlariSlice.reducer,
    kurumBonusTanimlariTestBazli: kurumBonusTanimlariTestBazliSlice.reducer,
    kurumBonusTanimlariTestVeVeriyeGore: kurumBonusTanimlariTestVeVeriyeGoreSlice.reducer,
    yetkiTanim: YetkiTanimSlice.reducer,
    kurumMailGonderimAyarlari: KurumMailGonderimAyarlariSlice.reducer,
    hastaUyari: HastaUyariSlice.reducer,
    hastaKaraListe: HastaKaraListeSlice.reducer,
    sonucIzlemeTanim: SonucIzlemeTanimSlice.reducer,
    redPanik: RedPanikSlice.reducer,
    testYinele: TestYineleSlice.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ serializableCheck: false }).concat([api.middleware, apiMiddleware])
  //middleware: [api.middleware, thunk]
});
export default store;
export type RootState = ReturnType<typeof store.getState>;
//type AppAction = ReturnType<typeof store.dispatch>;
//export type AppDispatch = ThunkDispatch<RootState, any, any>;
export const useAppDispatch = () => useDispatch<any>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
